<template>
  <v-main>
    <head>
      <title>
        Join Foraje!
      </title>
      <meta name="description" content="Create an account on Foraje, and start sharing!">
    </head>
    <v-container>
      <v-col cols="12" class="text-center">
        <h1>
          Join Foraje
        </h1>

      </v-col>
      <v-row >
        <v-col cols="12" sm="6" offset-sm="3">
          <v-alert dismissible color="error" text icon="mdi-alert-outline" v-model="erroralert" style="margin-bottom: 2px">Sorry! Something seems to have gone wrong, we automatically track errors, so we'll try to figure out what happened. Try again later please!</v-alert>
          <v-alert dismissible color="success" text icon="mdi-check-circle" v-model="signupalert" style="margin-bottom: 2px">Success! Just follow the link in the verification email we sent to get started. Thanks for joining us!</v-alert>
          <v-alert dismissible color="error" text icon="mdi-alert-outline" v-model="termsalert" style="margin-bottom: 2px">If you would like to create an account on Foraje, you must accept and agree to the terms and conditions, content policy, and privacy policy</v-alert>
          <v-card>
            <v-card-text>
              <v-container>
                <form @submit.prevent="SignUp">
                  <v-row >
                    <v-col cols="12">
                      <v-text-field
                        name="email"
                        label="Email"
                        id="email"
                        v-model="email"
                        type="email"
                        hint="A real email, since you'll need to verify it"

                        required></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row >
                    <v-col cols="12">
                      <v-text-field
                        name="password"
                        label="Password"
                        id="password"
                        v-model="password"
                        :type="password_show ? 'text' : 'password'"
                        hint="At least 8 characters, up to 255, no special requirements just please don't use common words/passwords."
                        min="8"
                        :counter="255"
                        required
                        :append-icon="password_show ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="password_show = !password_show"

                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row  >


                    <v-checkbox
                      color="green"
                      v-model="termscheckbox"
                    >
                      <label slot="label">
                        Check here to indicate you have read and agree to the <router-link @click.stop to="/policies/terms">terms and conditions,</router-link> the <router-link @click.stop to="/policies/content">content policy</router-link> and the <router-link @click.stop to="/policies/privacy">privacy policy</router-link>
                      </label>
                    </v-checkbox>

                  </v-row>
                  <v-row  >

                    <v-checkbox
                      color="green"
                      v-model="emailcheckbox"
                      label="Check here if you would like to receive email updates and newsletters"
                    >
                    </v-checkbox>

                  </v-row>
                  <v-row >
                    <v-col class="m11" cols="8" >
                      <v-btn color="primary" type="submit" :loading="signuploading" >
                        Sign up
                        <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                      </v-btn>
                    </v-col>

                  </v-row>
                </form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';


export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    termscheckbox: { required },
  },
  data() {
    return {
      email: '',
      password: '',
      password_show: false,
      // confirmPassword: '',
      signupalert: false,
      termscheckbox: false,
      emailcheckbox: false,
      termsalert: false,
      erroralert: false,
      signuploading: false,
      error: false,

    };
  },
  computed: {
    /* comparePasswords () {
          return this.password !== this.confirmPassword ? 'Passwords do not match' : true
        }, */
    user() {
      return this.$store.getters.user;
    },
    apiresponse() {
      return this.$store.getters.apiresponse;
    },


  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    },
  },
  methods: {
    SignUp() {
      if (this.termscheckbox === true) {
        axios.post('rest-auth/registration/', {
          email: this.email,
          password1: this.password,
          password2: this.password,
        })
          .then(() => {
            this.signupalert = true;
          })
          .then(() => {
            if (this.emailcheckbox === true) {
              axios.post('mailinglist/subscribe/', {
                email: this.email,
                email_consent: this.emailcheckbox,
              });
            }
          })
          .catch((error) => {
            // this regex fix is stilllll pretty hacky, but it seems to work now.
            const regex = /\[(.*?)\]/;
            this.signupalert = false;
            this.erroralert = true;
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline',
              alert_color: 'error',
              alert_message: `Our system says: ${regex.exec(error.response.request.response)[1].replace(/['"]+/g, '')}`,
              alert_model: true,
            });
          });
      } else { this.termsalert = true; }
    },
  },
  created() {
  },
};
</script>

<style scoped>
  .small{
    width: 50px
  }

</style>
